/**
 * @fileoverview DELETE handler for the "/engagement/landing_pages/:app_group_id/custom_subdomain" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesAppGroupIdCustomSubdomainCacheKeys } from "./constants";
import type {
  DeleteEngagementLandingPagesAppGroupIdCustomSubdomainProps,
  DeleteLandingPagesCustomSubdomainResult,
} from "./types";

export const deleteLandingPagesCustomSubdomain = reactQueryMutationAdapter(
  engagementLandingPagesAppGroupIdCustomSubdomainCacheKeys,
  (
    props: DeleteEngagementLandingPagesAppGroupIdCustomSubdomainProps
  ): Promise<DeleteLandingPagesCustomSubdomainResult> => {
    return fetch(`/engagement/landing_pages/${props.appGroupId}/custom_subdomain`, "DELETE", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
